@import 'styles/variables';
@import 'styles/mixins';

/* stylelint-disable css-modules/no-global-scoped-selector */
:global(#floating-ui-root) {
  position: relative;
  z-index: 100001;
  pointer-events: all;
}
/* stylelint-enable css-modules/no-global-scoped-selector */

.tooltip {
  @include sm-regular;

  position: absolute;
  align-items: center;
  padding: 4px;
  top: 0;
  left: 0;
  text-align: center;
  background: var(--neutral-90);
  color: $white;
  border-radius: 4px;
  width: fit-content;
  max-width: 235px;
  z-index: z-index(tooltip);
}

/**
 * ----------------------------------------
 * CSSTransition classnames
 * ----------------------------------------
 */

.enter {
  opacity: 0;
}

.enterActive {
  opacity: 1;
  transition: opacity 100ms ease-in-out;
}

.exit {
  opacity: 1;
}

.exitActive {
  opacity: 0;
  transition: opacity 100ms ease-in-out;
}
